/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { DETAIL_TAB } from '@interface/common'
import { Checkbox } from 'antd'
import CheckOnIcon from '@assets/images/icon/detail_tab_icon/check-on.png'
import CheckOffIcon from '@assets/images/icon/detail_tab_icon/check-off.png'
import CheckDisableIcon from '@assets/images/icon/detail_tab_icon/check-0.png'
import useRootStore from '@store/useRootStore'
import _ from 'lodash'

interface DetailTabProps {
  useFiltered?: boolean
}

export const DetailTab: React.FC<DetailTabProps> = observer(({ useFiltered = false }) => {

  const { matchupStore } = useRootStore()
  // prop에 따라 분리된 상태 참조
  const selectedTabs = useFiltered
    ? matchupStore.filteredSelectedDetailTabs
    : matchupStore.selectedDetailTabs

  const processedCount = useFiltered
    ? matchupStore.filteredProcessedMatchCount
    : matchupStore.processedMatchCount

  const closedCount = useFiltered
    ? matchupStore.filteredClosedMatchCount
    : matchupStore.closedMatchCount

  const { isLoading } = matchupStore

  // const { selectedDetailTabs, processedMatchCount, closedMatchCount, isLoading } = matchupStore

  const formatScoreCount = ({ count, isLoading }) => {
    if (isLoading || _.isNil(count)) {
      return '-'
    }
    if (count > 9999) {
      return '9999+'
    }
    return count.toString()
  }

  const getCheckIcon = (count: number, key: DETAIL_TAB): { src: string, alt: string } => {
    if (count === 0) {
      return {
        src: CheckDisableIcon,
        alt: '선택불가'
      }
    }
    return selectedTabs.includes(key) ? {
      src: CheckOnIcon,
      alt: '선택'
    } : {
      src: CheckOffIcon,
      alt: '미선택'
    }
  }

  const filterTabs = [
    {
      name: '진행중',
      key: DETAIL_TAB.PROCESSED,
      count: processedCount,
      icon: getCheckIcon(processedCount, DETAIL_TAB.PROCESSED),
    },
    {
      name: '종료',
      key: DETAIL_TAB.CLOSED,
      count: closedCount,
      icon: getCheckIcon(closedCount, DETAIL_TAB.CLOSED),
    },
  ]

  const onClickTab = (key) => {
    if (useFiltered) {
      matchupStore.setFilteredSelectedDetailTabs(prev =>
        prev.includes(key) ? prev.filter(i => i !== key) : [...prev, key],
      )
    } else {
      matchupStore.setSelectedDetailTabs(prev =>
        prev.includes(key) ? prev.filter(i => i !== key) : [...prev, key],
      )
    }
  }

  return (
    <div className="detail-tab">
      {filterTabs.map((tab) => (
        <Checkbox
          key={tab.key}
          value={tab.key}
          onChange={() => onClickTab(tab.key)}
          checked={selectedTabs.includes(tab.key)}
          disabled={tab.count === 0}
        >
          <div className="tab-item">
            <img className="check-icon" src={tab.icon.src} alt={`${tab.name} ${tab.icon.alt}`}/>
            <span className="txt">{tab.name}</span>
            <span className="num">{formatScoreCount({
              count: tab.count,
              isLoading: isLoading,
            })}</span>
          </div>
        </Checkbox>
      ))}

    </div>
  )
})
